import React from "react";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import Navbar from "../../Components/Navbar/Navbar/Navbar";
import TopBar from "../../Components/TopBar/TopBar";

const Terms = () => {
  return (
    <>
      <TopBar />
      <Header />
      <Navbar />

      <div className="w-full text-center justify-center item-center ">
        <h1 className="font-bold text-5xl text-gray-700 py-16">
          Terms and Conditions
        </h1>
      </div>
      <div className="container mx-auto px-4">
        <div className="w-full md:w-10/12 mx-auto pt-8 pb-16 text-lg">
          <p className="mt-4 text-xl">
            <span className="font-bold text-2xl mr-2">1.1</span> Welcome to Mamar Dukan.com. Mamar Dukan Limited (“Mamar Dukan”) provides
            access to the Mamar Dukan.com website or the mobile application/app or
            any other media ("Website") to you subject to the terms and
            conditions (“Terms”) set out on this page. By using the Website,
            you, a registered or guest user in terms of the eligibility criteria
            set out herein (“User”) agree to be bound by the Terms. Please read
            them carefully as your continued usage of the Website, you signify
            your agreement to be bound by these Terms. If you do not want to be
            bound by the Terms, you must not subscribe to or use the Website or
            our services.{" "}
          </p>
          <p className="mt-4 text-xl">
          <span className="font-bold  text-2xl mr-2">1.2 </span> By impliedly or expressly accepting these Terms, you also accept
            and agree to be bound by Mamar Dukan Policies (including but not limited
            to Privacy Policy available at https://Mamar Dukan.com/t/PrivacyInfo) as
            amended from time to time.{" "}
          </p>
          <p className="mt-4 text-xl">
          <span className="font-bold  text-2xl mr-2">1.3 </span> In these Terms, references to "you", "User" shall mean the end
            user/customer accessing the Website, its contents and using the
            Services offered through the Website. References to the “Website”,
            "Mamar Dukan", “Mamar Dukan.com”, "we", "us" and "our" shall mean the
            Website and/or Mamar Dukan Limited.{" "}
          </p>
          <p className="mt-4 text-xl">
          <span className="font-bold  text-2xl mr-2">1.4 </span> The contents set out herein form an electronic record in terms
            of তথ্য ও যোগাযোগ প্রযুক্তি আইন, ২০০৬ (Information & Communication
            Technology Act, 2006) and rules there under as applicable and as
            amended from time to time. As such, this document does not require
            any physical or digital signatures and forms a valid and binding
            agreement between the Website and the User.{" "}
          </p>
          <p className="mt-4 text-xl">
          <span className="font-bold text-2xl mr-2">1.5 </span> The Website is operated by Mamar Dukan Limited., a company
            incorporated under the laws of Bangladesh having its registered
            office at 165 DIT Extension Road, Fakirapool, Dhaka, Bangladesh. All
            references to the Website in these Terms shall deem to refer to the
            aforesaid entity in inclusion of the online portal.{" "}
          </p>
          <p className="mt-4 text-xl">
          <span className="font-bold text-2xl mr-2">1.6 </span> This Website may also contain links to other websites, which are
            not operated by Mamar Dukan, and Mamar Dukan has no control over the linked
            sites and accepts no responsibility for them or for any loss or
            damage that may arise from your use of them. Your use of the linked
            sites will be subject to the terms of use and service contained
            within each such site.{" "}
          </p>
          <p className="mt-4 text-xl">
          <span className="font-bold  text-2xl mr-2">1.7 </span> We reserve the right to change these Terms at any time. Such
            changes will be effective when posted on the Website. By continuing
            to use the Website after we post any such changes, you accept the
            Terms as modified.{" "}
          </p>
          <p className="mt-4 text-xl">
          <span className="font-bold text-2xl mr-2">1.8 </span> These Terms will continue to apply until terminated by either
            You or Mamar Dukan in accordance with the terms set out below:{" "}
          </p>
          <p className="mt-4 text-xl">
          <span className="font-bold text-2xl mr-2">1.9 </span> The agreement with Mamar Dukan can be terminated by (i) not
            accessing the Website; or (ii) closing Your Account, if such option
            has been made available to You.{" "}
          </p>
          <p className="mt-4 text-xl">
          <span className="font-bold text-2xl mr-2">1.10 </span>  Notwithstanding the foregoing, these provisions set out in
            these Terms which by their very nature survive are meant to survive
            termination, shall survive the termination / expiry of this
            agreement.{" "}
          </p>
        </div>
        </div>
      <Footer />
    </>
  );
};

export default Terms;
